import $ from 'jquery';

export default function cookieWidgetA11y() {
    var openCookieText = $().isWelshPage() ? 'Agor y naidlen cwcis' : 'Open cookie pop-up widget',
        closeCookieText = $().isWelshPage() ? 'Cau\'r naidlen cwcis' : 'Close cookie pop-up widget',
        lang = $().isWelshPage() ? 'cy' : 'en';

    const target = document.querySelector('body'),
        observer = new MutationObserver(function() {
            if ($('.CookiebotWidget-logo').length) {
                $('.CookiebotWidget-logo').attr('aria-label', openCookieText).attr('lang', lang);
                $('.CookiebotWidget-logo').on('click', function() {
                    // TODO: investigate CookiebotOnDialogDisplay event
                    setTimeout(() => {
                        $('.CookiebotWidget-close').attr('aria-label', closeCookieText).attr('lang', lang);
                    }, 500);
                });
                observer.disconnect();
            }
        }),

        config = { childList: true };

    observer.observe(target, config);
}
